export default "__VITE_ASSET__BSmeZ$m4__"